/**
 * Client-side check of headers.
 * @returns True if found PardusBrowser in user-agent navigator headers
 */
export const isPardusBrowser = () => {
  return navigator.userAgent.includes('PardusBrowser');
};

export const isChromeOrEdge = () => {
  const ua = navigator.userAgent;
  const isChrome = /Chrome/.test(ua) && !/Edg|OPR|Brave\//.test(ua);
  const isEdge = /Edg/.test(ua);
  return isChrome || isEdge;
};

export const isOfficialChromeOrEdge = () => {
  const ua = navigator.userAgent;
  const vendor = navigator.vendor;

  const isEdge = /Edg\/\d+/.test(ua);

  const isChrome =
    /Chrome\/\d+/.test(ua) &&
    vendor === 'Google Inc.' &&
    !/OPR|Brave|Vivaldi|YaBrowser|SamsungBrowser/.test(ua);

  return isChrome || isEdge;
};